import React, { useContext, useState } from 'react'
import Books from '../../../assets/pngwing.com.png'
import { Button, styled, Typography, Box } from '@mui/material'
import ErrorLayout from '../errorLayout'
import { useKeycloak } from '@react-keycloak/web'
import { PermissionsContext } from '../../../providers/permissions'

const ErroCode = styled(Typography)(() => ({
  fontSize: '0.85rem',
  color: 'rgba(0,0,0,0.6)',
  textAlign: 'center'
}))
const ErroTitle = styled(Typography)(() => ({
  fontSize: '2.25rem',
  lineHeight: '2.5rem',
  textAlign: 'center'
}))

const StyledBooks = styled('img')(() => ({
  height: '80vh',
  position: 'absolute',
  right: '-10vw',
  bottom: '-10vh',
  zIndex: '-1'
}))

const ErrorDescription = styled(Typography)(() => ({
  background: 'transparent',
  marginTop: '1rem',
  fontSize: '1.15rem',
  textAlign: 'center'
}))

// Textos fixos e amigáveis por categoria de falha. Nunca exibir a mensagem
// técnica original vinda do backend (heurística 9 de Nielsen).
const REASON_CONTENT = {
  unauthorized: {
    title: 'Sessão expirada',
    description:
      'Sua sessão expirou ou você não tem autorização para acessar o sistema. Faça login novamente.',
    showRetry: false
  },
  not_found: {
    title: 'Cadastro não encontrado',
    description:
      'Não localizamos seus dados de cadastro no sistema. Entre em contato com o suporte para verificar seu acesso.',
    showRetry: true
  },
  network: {
    title: 'Falha de conexão',
    description:
      'Não foi possível se conectar ao sistema. Verifique sua internet e tente novamente.',
    showRetry: true
  },
  server: {
    title: 'Não foi possível carregar seu perfil',
    description:
      'Identificamos um problema com os dados do seu cadastro. Tente novamente ou entre em contato com o suporte.',
    showRetry: true
  }
}

const AccessErrorPage = () => {
  const { keycloak } = useKeycloak()
  const { permissionsError, retryPermissions } = useContext(PermissionsContext)
  const [retrying, setRetrying] = useState(false)

  const content =
    REASON_CONTENT[permissionsError?.reason] || REASON_CONTENT.server

  const handleRetry = async () => {
    setRetrying(true)
    await retryPermissions()
    setRetrying(false)
  }

  return (
    <ErrorLayout>
      <StyledBooks src={Books} />
      <ErroTitle>{content.title}</ErroTitle>
      <ErrorDescription>{content.description}</ErrorDescription>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'center',
          gap: 1,
          mt: { xs: 6, md: 3 }
        }}
      >
        {content.showRetry && (
          <Button
            onClick={handleRetry}
            disabled={retrying}
            variant="outlined"
            color="leitura"
          >
            {retrying ? 'Tentando novamente...' : 'Tentar novamente'}
          </Button>
        )}
        <Button
          onClick={() => {
            keycloak.logout()
            keycloak.authenticated = false
          }}
          variant="contained"
          color="leitura"
        >
          Voltar para o login
        </Button>
      </Box>
      {permissionsError?.status > 0 && (
        <ErroCode>
          Código de referência para o suporte: {permissionsError.status}
        </ErroCode>
      )}
    </ErrorLayout>
  )
}

export default AccessErrorPage
